import React from 'react';
import { SvgIcon } from '@mui/material';

export default function TrainingSelectedIcon(props: any) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      {...props}
    >
      <g transform="translate(-1037 -392)">
        <rect
          width="25"
          height="25"
          transform="translate(1037 392)"
          fill="none"
        />
        <g transform="translate(1012.466 -394.604)">
          <circle
            cx="2.5"
            cy="2.5"
            r="2.5"
            transform="translate(27.534 788.604)"
            fill="#9aa0ae"
          />
          <path
            d="M37.534,801.252a.833.833,0,1,0,0-1.667H29.2a1.666,1.666,0,0,0-1.667,1.667v10.806a.861.861,0,0,0,1.72.058l.365-5.475a.416.416,0,0,1,.83,0l.365,5.475a.861.861,0,0,0,1.72-.057v-9.972a.834.834,0,0,1,.834-.834h4.167Z"
            transform="translate(0 -4.314)"
            fill="#9aa0ae"
          />
          <path
            d="M49.348,790.81H43.514a.833.833,0,0,0-1.667,0H38.515v1.667h10v8.333h-10v1.667h1.433l-1.408,5.632a.833.833,0,1,0,1.617.4l1.509-6.035H43.7l1.509,6.035a.833.833,0,1,0,1.616-.4l-1.408-5.632h3.933a.833.833,0,0,0,.834-.833v-10A.833.833,0,0,0,49.348,790.81Z"
            transform="translate(-4.314 -0.539)"
            fill="#9aa0ae"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
